import { Mark, mergeAttributes } from '@tiptap/core';

export interface CommentAnchorAttrs {
  id: string | null;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    commentAnchor: {
      setCommentAnchor: (attrs: CommentAnchorAttrs) => ReturnType;
      unsetCommentAnchor: () => ReturnType;
    };
  }
}

export const CommentAnchorMark = Mark.create({
  name: 'commentAnchor',
  inclusive: false,
  spanning: false,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-aab-comment-id'),
        renderHTML: (attrs) => (attrs.id ? { 'data-aab-comment-id': attrs.id } : {}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-aab-comment-id]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'aab-comment-anchor-mark' }),
      0,
    ];
  },

  addCommands() {
    return {
      setCommentAnchor:
        (attrs) =>
        ({ commands }) =>
          commands.setMark(this.name, attrs),
      unsetCommentAnchor:
        () =>
        ({ commands }) =>
          commands.unsetMark(this.name),
    };
  },
});
